<template>
    <div class="animated fadeIn">
        <b-row>
            <b-col cols="12">
                <component-header
                    title="Service Request Category Create"
                    :hasSearch="false"
                    :hasReload="false"
                    :hasCreate="false"
                    :hasback="true"
                    @back-press="$router.push('/setup/service-request')"
                />
            </b-col>

            <b-col cols="12">
                <ValidationObserver v-slot="{ invalid }" ref="observer">
                    <b-card>
                        <!-- Category -->
                        <b-row>
                            <b-col md="4">
                                <span>Category</span>
                            </b-col>
                            <b-col md="8">
                                <ValidationProvider
                                    rules="required"
                                    v-slot="{ errors }"
                                    name="Category"
                                >
                                    <c-input
                                        inputType="text"
                                        labelText="Category"
                                        v-model="name"
                                    />
                                    <span class="validate-error">{{
                                        errors[0]
                                    }}</span>
                                </ValidationProvider>
                            </b-col>
                        </b-row>

                        <!-- Scope (Tenant / Partner) -->
                        <b-row
                            v-if="
                                userRole === 'Tenant' || userRole === 'Partner'
                            "
                            class="mt-2"
                        >
                            <b-col md="4">
                                <span>Scope</span>
                            </b-col>
                            <b-col md="8">
                                <ValidationProvider
                                    rules="required"
                                    v-slot="{ errors }"
                                    name="Scope"
                                >
                                    <eb-select
                                        v-model="scope"
                                        :options="scope1Options"
                                        placeholder="Select scope"
                                    />
                                    <span class="validate-error">{{
                                        errors[0]
                                    }}</span>
                                </ValidationProvider>
                            </b-col>
                        </b-row>

                        <!-- Scope (Admin) -->
                        <b-row v-if="userRole === 'Admin'" class="mt-2">
                            <b-col md="4">
                                <span>Scope</span>
                            </b-col>
                            <b-col md="8">
                                <eb-select
                                    v-model="scope"
                                    :options="scopeOptions"
                                    placeholder="Select scope"
                                />
                            </b-col>
                        </b-row>

                        <!-- Description -->
                        <b-row class="mt-2">
                            <b-col md="4">
                                <span>Description</span>
                            </b-col>
                            <b-col md="8">
                                <ValidationProvider
                                    rules="required"
                                    v-slot="{ errors }"
                                    name="Description"
                                >
                                    <b-form-textarea
                                        v-model="description"
                                        placeholder="Enter description..."
                                        rows="3"
                                        max-rows="6"
                                    />
                                    <span class="validate-error">{{
                                        errors[0]
                                    }}</span>
                                </ValidationProvider>
                            </b-col>
                        </b-row>

                        <!-- Severity -->
                        <b-row class="mt-2">
                            <b-col md="4">
                                <span>Severity</span>
                            </b-col>
                            <b-col md="8">
                                <ValidationProvider
                                    rules="required"
                                    v-slot="{ errors }"
                                    name="Severity"
                                >
                                    <eb-select
                                        v-model="severity"
                                        :options="severityOptions"
                                        placeholder="Select Severity"
                                    />
                                    <span class="validate-error">{{
                                        errors[0]
                                    }}</span>
                                </ValidationProvider>
                            </b-col>
                        </b-row>
                    </b-card>

                    <!-- Save Button -->
                    <div class="text-center mb-3">
                        <eb-button
                            class="fixed-width-btn"
                            :disabled="invalid"
                            classic="btn-primary"
                            text="Save"
                            @click.prevent="handleSubmit"
                        />
                    </div>
                </ValidationObserver>
            </b-col>
        </b-row>
    </div>
</template>

<script>
import cInput from "@/components/Common/CustomInput";
import ebButton from "@/components/FormElements/Button";
import ebSelect from "@/components/FormElements/Select.vue";
import { ValidationObserver, ValidationProvider } from "vee-validate";
import ComponentHeader from "@/components/componentNewHeader";

export default {
    name: "CreateServiceRequestCategory",
    components: {
        ebButton,
        ebSelect,
        cInput,
        ValidationObserver,
        ValidationProvider,
        ComponentHeader,
    },
    data() {
        return {
            submitting: false,
            scope: "",
            scope1Options: ["AGENT", "PARTNER", "CUSTOMER"],
            scopeOptions: ["TENANT"],
            severityOptions: ["Low", "Medium", "High", "Critical"],
            name: "",
            severity: "",
            description: "",
        };
    },
    computed: {
        userRole() {
            return (
                this.$store.getters["auth/getUserRole"] ||
                JSON.parse(sessionStorage.getItem("userLogin"))?.role
            );
        },
    },
    methods: {
        async handleSubmit() {
            const isValid = await this.$refs.observer.validate();
            if (!isValid) return;

            this.submitting = true;
            const dataObj = {
                parent: null,
                scope: this.scope,
                name: this.name,
                description: this.description,
                severity: this.severity,
            };

            try {
                await this.$store.dispatch(
                    "servicerequest/createRequest",
                    dataObj,
                );

                this.$swal({
                    title: "Success",
                    text: "Request added successfully!",
                    type: "success",
                });

                await this.$store.dispatch(
                    "servicerequest/fetchServicerequestList",
                );

                this.$router.push("/setup/service-request");
            } catch (error) {
                this.$toasted.error(error.message || "Something went wrong");
            } finally {
                this.submitting = false;
            }
        },
    },
};
</script>

<style scoped>
.fixed-width-btn {
    width: 100px;
    font-size: 15px;
}
.validate-error {
    color: red;
    font-size: 12px;
}
</style>
